/**
 * 🏗️ SCHEMA BUILDER
 * Location: src/registered/site-admin/components/Workflow-esg/schemaBuilder.js
 */
export default function buildSchema(presentation, dimensions, calculations) {
    console.group("🏗️ [BUILD_SCHEMA] Finalizing ESG Taxonomy");
    
    // Safety check for empty presentation data
    if (!presentation || !presentation.concepts) {
        console.error("❌ [BUILD_SCHEMA] No presentation concepts provided.");
        console.groupEnd();
        return { concepts: {}, roots: [], meta: {} };
    }

    const { concepts, roots } = presentation;

    /**
     * 1. 🧩 ATTACH DIMENSIONS (Definition Linkbase)
     * We map Members to their respective Axes.
     * Guard: includes() prevents the "stuttering" duplicates you saw.
     */
    dimensions.forEach(({ axis, member }) => {
        if (concepts[axis]) {
            if (!concepts[axis].dimensions) {
                concepts[axis].dimensions = [];
            }
            
            // Only add the member if it isn't already registered to this axis
            if (!concepts[axis].dimensions.includes(member)) {
                concepts[axis].dimensions.push(member);
            }
        }
    });

    /**
     * 2. 🧮 ATTACH CALCULATIONS (Calculation Linkbase)
     * Maps mathematical summation relationships.
     */
    calculations.forEach(({ parent, child, weight }) => {
        if (concepts[child]) {
            // Concepts usually only have one calculation parent in ESRS
            concepts[child].calculation = { 
                parent, 
                weight: parseFloat(weight) 
            };
        }
    });

    console.log(`✅ Integration Complete: ${Object.keys(concepts).length} Concepts Processed.`);
    console.groupEnd();

    // 📦 RETURN FULL SCHEMA WITH META
    return {
        concepts,
        roots,
        meta: {
            conceptCount: Object.keys(concepts).length,
            rootCount: roots.length,
            dimensionPairs: dimensions.length,
            calculationRules: calculations.length,
            generatedAt: new Date().toISOString()
        }
    };
}